import { render, staticRenderFns } from "./BackupDiffModal.vue?vue&type=template&id=58f555e9"
import script from "./BackupDiffModal.vue?vue&type=script&lang=js"
export * from "./BackupDiffModal.vue?vue&type=script&lang=js"
import style0 from "./BackupDiffModal.vue?vue&type=style&index=0&id=58f555e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports